module.exports = __webpack_public_path__ + "static/error-ig-5-dec92ef50629dedd35583eb3b47ac02b.png";